import { CircleCheck, CircleX, Info } from 'lucide-react';
import { ReactNode } from 'react';
interface ToastProps {
  message?: string;
  header?: string;
  className?: string;
  contentClassName?: string;
  iconClassName?: string;
  icon?: ReactNode;
  variant?: 'success' | 'error' | 'info';
}

export default function StandardToast({
  header,
  message,
  className,
  contentClassName,
  icon,
  iconClassName = 'size-5 shrink-0',
  variant = 'success',
}: Readonly<ToastProps>) {
  let styles = 'bg-teal-100 border border-teal-200 text-sm text-teal-800';

  switch (variant) {
    case 'success':
      break;
    case 'info':
      styles = 'bg-blue-100 border border-blue-200 text-sm text-blue-800';
      break;
    case 'error':
      styles = 'bg-red-100 border border-red-200 text-sm text-red-800';
      break;
    default:
      break;
  }

  const defaultIcon =
    variant === 'success' ? (
      <CircleCheck className="size-full" />
    ) : variant === 'error' ? (
      <CircleX className="size-full" />
    ) : (
      <Info className="size-full" />
    );

  return (
    <div className={`my-2 w-full rounded-lg ${styles} ${className}`}>
      <div
        className={`flex p-4 items-${header ? 'start' : 'center'} gap-4 ${contentClassName}`}
      >
        <span className={`${iconClassName} [&>svg]:h-full! [&>svg]:w-full!`}>
          {icon ?? defaultIcon}
        </span>
        <div className="gap-y-3">
          {header && <p className="text-lg font-semibold">{header}</p>}
          {message && <p className="text-base leading-6">{message}</p>}
        </div>
      </div>
    </div>
  );
}
